var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile28X28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bound",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "follow",
    transform: "translate(2.500000, 2.500000)",
    fill: "#888888"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1787848,18.2459059 C20.7612978,16.4459569 21.7210003,14.0850386 21.7210003,11.4999569 C21.7210003,5.85509118 17.1448398,1.27899965 11.4999569,1.27899965 C5.85509118,1.27899965 1.27899965,5.85509118 1.27899965,11.4999569 C1.27899965,13.9152126 2.11671035,16.1347673 3.51741723,17.8839151 C4.11656073,15.5395568 5.76660742,13.6156667 7.93611133,12.6438029 C7.04540869,11.7399903 6.49573813,10.4991994 6.49573813,9.12998234 C6.49573813,6.36515579 8.73702783,4.12384885 11.5018544,4.12384885 C14.2666809,4.12384885 16.5080569,6.36515579 16.5080569,9.12998234 C16.5080569,10.5630243 15.9058601,11.8554789 14.9408101,12.7680028 C17.0880874,13.8275827 18.6832791,15.836084 19.1787848,18.2459059 Z M18.0435637,19.3521471 C17.8495877,16.7066904 16.0974211,14.4941219 13.7010541,13.6284317 C13.037275,13.9535938 12.2908684,14.1361848 11.5018544,14.1361848 C10.6503954,14.1361848 9.84861644,13.9235788 9.14662857,13.5485643 C6.72697409,14.3204146 4.91308711,16.4491482 4.59954288,19.0400949 C6.41785448,20.7050629 8.84026895,21.7210003 11.4999569,21.7210003 C13.9893013,21.7210003 16.2706972,20.831074 18.0435637,19.3521471 Z M11.4999569,23 C17.8512264,23 23,17.8512264 23,11.4999569 C23,5.14872181 17.8512264,0 11.4999569,0 C5.14872181,0 0,5.14872181 0,11.4999569 C0,17.8512264 5.14872181,23 11.4999569,23 Z M11.5018544,12.8571852 C13.5602943,12.8571852 15.2290572,11.1884223 15.2290572,9.12998234 C15.2290572,7.07154241 13.5602943,5.4028485 11.5018544,5.4028485 C9.44341445,5.4028485 7.77473778,7.07154241 7.77473778,9.12998234 C7.77473778,11.1884223 9.44341445,12.8571852 11.5018544,12.8571852 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile28X28);
export default __webpack_public_path__ + "static/media/profile-28x28.2df4482fde932a723dbdf6c1d86ec241.svg";
export { ForwardRef as ReactComponent };